import {Injectable} from '@angular/core';
import {SwUpdate, VersionReadyEvent} from '@angular/service-worker';
import {filter} from 'rxjs/operators';
import {WhatsNewContentService} from "../whats-new/whats-new-content.service";

@Injectable({providedIn: 'root'})
export class AppUpdateService {

  public isUpdateAvailable = false;
  public isUpdated = false;
  public isUpdatesEnabled = this.swUpdate.isEnabled;
  public canReloadApp = true;

  private whatsNewContentService: WhatsNewContentService;

  constructor(private swUpdate: SwUpdate) {
    this.subscribeForUpdate();
  }

  checkForUpdate() {
    this.swUpdate.checkForUpdate();
  }

  private subscribeForUpdate() {
    this.swUpdate.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe(() => {
        this.isUpdateAvailable = true;
        this.activateUpdate();
      });
  }

  private activateUpdate() {
    // Added timeout to display the update banner even for quick updates.
    setTimeout(() => {
      this.swUpdate.activateUpdate().then(() => {
        this.isUpdated = true;

        if (this.canReloadApp) {
          setTimeout(() => {
            this.whatsNewContentService?.clearCachedContent();
            document.location.reload();
          }, 3000);
        }
      });
    }, 3000);
  }

}
